// API URLS
export const API_URL = {
	USER_DATA: '/customer/code/', // /customer/code/:code
	CUSTOMER: '/customer/edit/', // patch customer status
	LIVENESS: '/liveness/edit/', // patch liveness status
	WEBRTC_CONNECTION: '/offer', //For Web RTC connection
	USER_VERIFICATION: '/verify', //For face match
	FACE_MATCH_RESULT: '/customer/', //For face match after websocket close
};
